export default {
  category: {
    title: '文章分类管理',
    addNew: '新增分类',
    createTitle: '新增分类',
    editTitle: '编辑分类',
    form: {
      category: '分类',
      categoryPlaceholder: '请输入分类名称',
      categoryRequired: '请输入分类名称',
      language: '语言',
      languagePlaceholder: '请选择语言',
      languageRequired: '请选择语言',
      isActive: '是否启用',
      isActivePlaceholder: '请选择状态',
      name: '分类名称',
      namePlaceholder: '请输入分类名称',
      nameRequired: '请输入分类名称',
      slug: '唯一标识',
      slugPlaceholder: '请输入唯一标识',
      description: '分类简介',
      descriptionPlaceholder: '请输入分类简介',
      sortOrder: '排序',
      sortOrderPlaceholder: '数字越小越靠前',
      seoTitle: 'SEO 标题',
      seoTitlePlaceholder: '请输入 SEO 标题',
      seoDescription: 'SEO 描述',
      seoDescriptionPlaceholder: '请输入 SEO 描述',
      seoKeywords: 'SEO 关键词',
      seoKeywordsPlaceholder: '多个关键词用逗号分隔',
      canonicalUrl: '规范化链接',
      canonicalUrlPlaceholder: '请输入规范化链接',
      ogTitle: 'OG 标题',
      ogTitlePlaceholder: '请输入 OG 标题',
      ogDescription: 'OG 描述',
      ogDescriptionPlaceholder: '请输入 OG 描述',
      ogImage: 'OG 图片',
      ogImagePlaceholder: '请输入 OG 图片链接',
    },
    table: {
      name: '分类名称',
      slug: '唯一标识',
      description: '分类简介',
      language: '语言',
      isActive: '状态',
      sortOrder: '排序',
      updateTime: '更新时间',
      action: '操作',
    },
    tabs: {
      basic: '基本信息',
      seo: 'SEO 设置',
      og: 'OG 设置',
    },
  },
  tag: {
    title: '文章标签管理',
    addNew: '新增标签',
    createTitle: '新增标签',
    editTitle: '编辑标签',
    form: {
      tag: '标签',
      tagPlaceholder: '请输入标签名称',
      language: '语言',
      languagePlaceholder: '请选择语言',
      languageRequired: '请选择语言',
      isActive: '是否启用',
      isActivePlaceholder: '请选择状态',
      name: '标签名称',
      namePlaceholder: '请输入标签名称',
      nameRequired: '请输入标签名称',
      slug: '唯一标识',
      slugPlaceholder: '请输入唯一标识',
      description: '标签简介',
      descriptionPlaceholder: '请输入标签简介',
      seoTitle: 'SEO 标题',
      seoTitlePlaceholder: '请输入 SEO 标题',
      seoDescription: 'SEO 描述',
      seoDescriptionPlaceholder: '请输入 SEO 描述',
      seoKeywords: 'SEO 关键词',
      seoKeywordsPlaceholder: '多个关键词用逗号分隔',
      canonicalUrl: '规范化链接',
      canonicalUrlPlaceholder: '请输入规范化链接',
      ogTitle: 'OG 标题',
      ogTitlePlaceholder: '请输入 OG 标题',
      ogDescription: 'OG 描述',
      ogDescriptionPlaceholder: '请输入 OG 描述',
      ogImage: 'OG 图片',
      ogImagePlaceholder: '请输入 OG 图片链接',
    },
    table: {
      name: '标签名称',
      slug: '唯一标识',
      description: '标签简介',
      language: '语言',
      isActive: '状态',
      usageCount: '使用次数',
      updateTime: '更新时间',
      action: '操作',
    },
    tabs: {
      basic: '基本信息',
      seo: 'SEO 设置',
      og: 'OG 设置',
    },
  },
  article: {
    title: '文章列表管理',
    addNew: '新增文章',
    createTitle: '新增文章',
    editTitle: '编辑文章',
    form: {
      keyword: '标题',
      keywordPlaceholder: '请输入文章标题',
      category: '分类',
      categoryPlaceholder: '请选择分类',
      categoryRequired: '请选择分类',
      language: '语言',
      languagePlaceholder: '请选择语言',
      languageRequired: '请选择语言',
      status: '状态',
      statusPlaceholder: '请选择状态',
      dateRange: '发布时间',
      startDate: '开始日期',
      endDate: '结束日期',
      title: '文章标题',
      titlePlaceholder: '请输入文章标题',
      titleRequired: '请输入文章标题',
      slug: '唯一标识',
      slugPlaceholder: '请输入唯一标识',
      summary: '摘要',
      summaryPlaceholder: '请输入文章摘要',
      content: '文章内容',
      coverImage: '封面图片',
      coverImagePlaceholder: '请输入封面图片链接',
      publishedAt: '发布时间',
      tags: '标签',
      tagsPlaceholder: '请选择标签',
      sortOrder: '排序',
      sortOrderPlaceholder: '数字越小越靠前',
      isTop: '是否置顶',
      seoEnabled: '启用 SEO',
      seoTitle: 'SEO 标题',
      seoTitlePlaceholder: '请输入 SEO 标题',
      seoDescription: 'SEO 描述',
      seoDescriptionPlaceholder: '请输入 SEO 描述',
      seoKeywords: 'SEO 关键词',
      seoKeywordsPlaceholder: '多个关键词用逗号分隔',
      canonicalUrl: '规范化链接',
      canonicalUrlPlaceholder: '例如：https://www.yoursite.com/article/Points/123',
      ogTitle: 'OG 标题',
      ogTitlePlaceholder: '请输入 OG 标题',
      ogDescription: 'OG 描述',
      ogDescriptionPlaceholder: '请输入 OG 描述',
      ogImage: 'OG 图片',
      ogImagePlaceholder: '请输入 OG 图片链接',
    },
    table: {
      id: 'ID',
      article: '文章',
      coreSeo: '核心SEO',
      coverImage: '封面图片',
      socialOg: '社交 OG',
      isTop: '置顶',
      status: '状态',
      viewCount: '文章访问统计（PV/UV）',
      action: '操作',
      title: '文章标题',
      category: '分类',
      tags: '标签',
      language: '语言',
      publisher: '发布人',
      updateTime: '更新时间',
      canonicalUrl: '规范化链接',
      seoKeywords: '关键词',
      dynamicParams: '动态参数',
      noImage: '无图片',
      noOgImage: '无OG图',
      publishedAt: '发布时间',
    },
    status: {
      pending: '待审核',
      published: '已发布',
      rejected: '已拒绝',
    },
      actions: {
        preview: '预览',
        edit: '编辑',
        seoEdit: 'SEO编辑',
        delete: '删除',
        approve: '通过',
        reject: '拒绝',
        confirmApprove: '确定要审核通过这篇文章吗？',
        confirmReject: '确定要拒绝这篇文章吗？',
      },
      seoEdit: 'SEO和OG编辑',
      preview: {
        original: '原始内容',
        processed: '替换后内容',
      },
    tabs: {
      basic: '基本信息',
      seo: 'SEO 设置',
      og: 'OG 设置',
    },
  },
  internalLink: {
    title: '内链关键词管理',
    add: '新增关键词',
    edit: '编辑关键词',
    keyword: '关键词',
    keywordTag: '关键词标签',
    keywordPlaceholder: '请输入关键词',
    url: 'URL',
    urlPlaceholder: '请输入 URL',
    isBrand: '品牌词',
    maxReplacement: '最大替换次数',
    maxReplacementPlaceholder: '请输入最大替换次数（默认：普通词5次，品牌词2次）',
    isActive: '是否启用',
  }
};

